import { createTheme } from '@mantine/core';

export const theme = createTheme({
    primaryColor: 'primary',
    primaryShade: 0,
    components: {
        Tooltip: {
            defaultProps: {
                fz: '11px',
                px: 8,
                py: 3,
            }
        }
    },
    colors: {
        primary: [
            '#0074d9', // Color principal
            '#1247dc',
            '#103ec3',
            '#0e35aa',
            '#0c2c91',
            '#0a2378',
            '#081a5f',
            '#333F49',
            '#04082d',
            '#020014'
        ],
        secondary: [
            '#1A1449', // Color secundario (azul más claro que complementa al primario)
            '#4470e0',
            '#3b63c7',
            '#3256ae',
            '#294995',
            '#203c7c',
            '#172f63',
            '#0e224a',
            '#051531',
            '#020818'
        ],
        white: [
            '#ffffff',
            '#f5f5f5',
            '#ebebeb',
            '#e1e1e1',
            '#d7d7d7',
            '#cdcdcd',
            '#c3c3c3',
            '#b9b9b9',
            '#afafaf',
            '#6f736b'
        ],
        error: [
            '#fff5f5',
            '#ffe3e3',
            '#ffc9c9',
            '#ffa8a8',
            '#ff8787',
            '#ff6b6b',
            '#fa5252',
            '#f03e3e',
            '#e03131',
            '#c92a2a',
          ],
    }
}); 